export const ProgressGroupUtil = {
  lessThanHalf: (currentNumber: number, maxNumber: number): boolean => {
    return currentNumber < maxNumber / 2;
  },
};
